var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      staticClass: "drawer",
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        direction: _vm.direction,
        size: _vm.width,
        "wrapper-closable": false,
        "destroy-on-close": true,
        "append-to-body": true,
      },
      on: { close: _vm.close },
    },
    [
      _vm.visible
        ? [
            _c(_vm.type, {
              tag: "components",
              attrs: {
                "goods-id": _vm.goodsId,
                "is-dou": _vm.isDou,
                success: _vm.success,
              },
              on: {
                close: function ($event) {
                  _vm.visible = false
                },
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }